// WARNING: this file is AUTOGENERATED, only main.ts and index.ts are editable
// rerun yarn generate:enums to update

/* eslint-disable */
interface IParsedSubscriptionState {
  Current: {"enum_constant":"Current"};
  Expired: {"enum_constant":"Expired"};
  ExpiringSoon: {"enum_constant":"ExpiringSoon"};
  None: {"enum_constant":"None"};
  Recurring: {"enum_constant":"Recurring"};
}

export type SubscriptionStateId = keyof IParsedSubscriptionState;
export type SubscriptionStateData = IParsedSubscriptionState[SubscriptionStateId];
const data: SubscriptionStateData[] = [{"enum_constant":"Current"},{"enum_constant":"Expired"},{"enum_constant":"ExpiringSoon"},{"enum_constant":"None"},{"enum_constant":"Recurring"}];
export default data;
